// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-page {
    padding: 20px;
}

.page-builder {
    min-height: 400px;
}

/* Block Container Styles */
.block-container {
    margin-bottom: 20px;
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius);
    overflow: hidden;
    transition: all 0.3s ease;
    background: var(--bs-body-bg-color);
}

.block-container:hover {
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.block-header {
    background: var(--gray-bg-color);
    padding: 10px 15px;
    border-bottom: 1px solid var(--border-color);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.block-title {
    font-weight: 600;
    color: var(--card-title-color);
    margin: 0;
    font-size: 14px;
}

.block-actions {
    display: flex;
    gap: 10px;
}

.block-action-btn {
    padding: 4px 8px;
    border: 1px solid var(--border-color);
    background: var(--bs-body-bg-color);
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 4px;
}

.block-action-btn:hover {
    background: var(--gray-bg-color);
}

.block-action-btn.edit {
    color: var(--admin-color);
    border-color: var(--admin-color);
}

.block-action-btn.edit:hover {
    background: var(--admin-color);
    color: white;
}

.block-action-btn.remove {
    color: var(--bs-red);
    border-color: var(--bs-red);
}

.block-action-btn.remove:hover {
    background: var(--bs-red);
    color: white;
}

.block-content {
    padding: 0;
}

/* Add Block Button Styles */
.add-block-container {
    position: relative;
    margin-top: 20px;
}

.add-block-btn {
    width: 100%;
    padding: 15px;
    border: 2px dashed var(--admin-color);
    background: transparent;
    color: var(--admin-color);
    border-radius: var(--border-radius);
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.add-block-btn:hover {
    background: var(--admin-color);
    color: white;
    border-style: solid;
}

.add-block-btn .mdi {
    font-size: 20px;
}

.block-options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: var(--bs-body-bg-color);
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    z-index: 1000;
    margin-top: 10px;
}

.block-options-header {
    padding: 15px;
    border-bottom: 1px solid var(--border-color);
    background: var(--gray-bg-color);
    border-radius: var(--border-radius) var(--border-radius) 0 0;
}

.block-options-header h4 {
    margin: 0;
    font-size: 16px;
    color: var(--card-title-color);
}

.block-options-list {
    padding: 10px;
}

.block-option {
    padding: 12px 15px;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 5px;
}

.block-option:hover {
    background: var(--gray-bg-color);
}

.block-option:last-child {
    margin-bottom: 0;
}

.block-option .mdi {
    font-size: 18px;
    color: var(--admin-color);
    width: 24px;
    text-align: center;
}

.block-option span:last-child {
    font-size: 14px;
    color: var(--text-color);
}

/* Responsive Design */
@media (max-width: 768px) {
    .home-page {
        padding: 10px;
    }
    
    .block-actions {
        flex-direction: column;
        gap: 5px;
    }
    
    .block-action-btn {
        font-size: 10px;
        padding: 3px 6px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/HomePage/HomePage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,2BAA2B;AAC3B;IACI,mBAAmB;IACnB,qCAAqC;IACrC,mCAAmC;IACnC,gBAAgB;IAChB,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,4CAA4C;IAC5C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,qCAAqC;IACrC,mCAAmC;IACnC,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,qCAAqC;IACrC,uBAAuB;IACvB,yBAAyB;IACzB,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,mCAAmC;IACnC,qCAAqC;IACrC,mCAAmC;IACnC,uCAAuC;IACvC,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4CAA4C;IAC5C,gCAAgC;IAChC,4DAA4D;AAChE;;AAEA;IACI,SAAS;IACT,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":[".home-page {\n    padding: 20px;\n}\n\n.page-builder {\n    min-height: 400px;\n}\n\n/* Block Container Styles */\n.block-container {\n    margin-bottom: 20px;\n    border: 1px solid var(--border-color);\n    border-radius: var(--border-radius);\n    overflow: hidden;\n    transition: all 0.3s ease;\n    background: var(--bs-body-bg-color);\n}\n\n.block-container:hover {\n    box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n}\n\n.block-header {\n    background: var(--gray-bg-color);\n    padding: 10px 15px;\n    border-bottom: 1px solid var(--border-color);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.block-title {\n    font-weight: 600;\n    color: var(--card-title-color);\n    margin: 0;\n    font-size: 14px;\n}\n\n.block-actions {\n    display: flex;\n    gap: 10px;\n}\n\n.block-action-btn {\n    padding: 4px 8px;\n    border: 1px solid var(--border-color);\n    background: var(--bs-body-bg-color);\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.block-action-btn:hover {\n    background: var(--gray-bg-color);\n}\n\n.block-action-btn.edit {\n    color: var(--admin-color);\n    border-color: var(--admin-color);\n}\n\n.block-action-btn.edit:hover {\n    background: var(--admin-color);\n    color: white;\n}\n\n.block-action-btn.remove {\n    color: var(--bs-red);\n    border-color: var(--bs-red);\n}\n\n.block-action-btn.remove:hover {\n    background: var(--bs-red);\n    color: white;\n}\n\n.block-content {\n    padding: 0;\n}\n\n/* Add Block Button Styles */\n.add-block-container {\n    position: relative;\n    margin-top: 20px;\n}\n\n.add-block-btn {\n    width: 100%;\n    padding: 15px;\n    border: 2px dashed var(--admin-color);\n    background: transparent;\n    color: var(--admin-color);\n    border-radius: var(--border-radius);\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n\n.add-block-btn:hover {\n    background: var(--admin-color);\n    color: white;\n    border-style: solid;\n}\n\n.add-block-btn .mdi {\n    font-size: 20px;\n}\n\n.block-options {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: var(--bs-body-bg-color);\n    border: 1px solid var(--border-color);\n    border-radius: var(--border-radius);\n    box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n    z-index: 1000;\n    margin-top: 10px;\n}\n\n.block-options-header {\n    padding: 15px;\n    border-bottom: 1px solid var(--border-color);\n    background: var(--gray-bg-color);\n    border-radius: var(--border-radius) var(--border-radius) 0 0;\n}\n\n.block-options-header h4 {\n    margin: 0;\n    font-size: 16px;\n    color: var(--card-title-color);\n}\n\n.block-options-list {\n    padding: 10px;\n}\n\n.block-option {\n    padding: 12px 15px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 5px;\n}\n\n.block-option:hover {\n    background: var(--gray-bg-color);\n}\n\n.block-option:last-child {\n    margin-bottom: 0;\n}\n\n.block-option .mdi {\n    font-size: 18px;\n    color: var(--admin-color);\n    width: 24px;\n    text-align: center;\n}\n\n.block-option span:last-child {\n    font-size: 14px;\n    color: var(--text-color);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .home-page {\n        padding: 10px;\n    }\n    \n    .block-actions {\n        flex-direction: column;\n        gap: 5px;\n    }\n    \n    .block-action-btn {\n        font-size: 10px;\n        padding: 3px 6px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
